import { render, staticRenderFns } from "./CenterUseList.vue?vue&type=template&id=67a2ce62&scoped=true"
import script from "./CenterUseList.vue?vue&type=script&lang=js"
export * from "./CenterUseList.vue?vue&type=script&lang=js"
import style0 from "./CenterUseList.vue?vue&type=style&index=0&id=67a2ce62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a2ce62",
  null
  
)

export default component.exports